//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductDocumentItem from "~/components/product/main-product-card/ProductDocumentItem";

export default {
  name: "DescriptionMainCard",
  data() {
    return {
      activeTab: "description",

      isSmallDescription: false,
      isShowButtonMoreDescription: false
    }
  },

  props: {
    category: String,
    description: {
      type: String,
    },
    showAttrItemprop: Boolean,
  },

  components: {
    ProductDocumentItem,
  },
  mounted: function () {
    this.initFunctionMoreDescription();
  },

  computed: {
    tabs: function () {
      return [
        {label: "Описание", value: "description"},
        {label: "Документы", value: "documents", disabled: !this.isShowDocumentsTab},
        {label: "Как читать рецепт?", value: "how-read-recipe", disabled: !Boolean(this.howReadRecipe)},
      ]
    },


    isShowDocumentsTab() {
      return Boolean(this.getDocumentsList.length > 0)
    },

    getDocumentsList() {
      return this.product?.files || [];
    },
  },

  methods: {
    initFunctionMoreDescription: function () {
      const fullHeight = this.$refs.refDescription.getBoundingClientRect();

      if (fullHeight < 66) {
        return
      }

      this.isShowButtonMoreDescription = true;
      this.isSmallDescription = true;
    },
    changeSmallDescription: function () {
      this.isSmallDescription = !this.isSmallDescription;
    },


    changeActiveTab: function (activeTab) {
      this.activeTab = activeTab;
    },
  },
}
